import * as Mod1 from "./discourse/initializers/github-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/initializers/github-admin-plugin-configuration-nav": Mod1,
};
export default compatModules;
